export default "__VITE_ASSET__BK9k82yN__"